import { get, post } from '../utils/http';

export const fetchDbs = (id) => get('DB_FETCH', `/admin/config`);

// Database
export const editDb = (db) => ({ type: 'DB_EDIT', payload: db });

export const cancelDb = () => ({ type: 'DB_CANCEL' });

export const deleteDb = (key) => {
	let form = new FormData();
	form.append('key', key);
	return post('DB_DELETE', `/admin/db/delete`, form);
};

export const saveDb = ({ key, name, hidden, responsibleLawyer }) => {
	let form = new FormData();
	form.append('key', key);
	form.append('name', name);
	form.append('hidden', hidden);
	form.append('responsibleLawyer', responsibleLawyer);

	return post('DB_SAVE', `/admin/db/update`, form);
};

export const showNewDbDialog = () => ({ type: 'CONFIG_NEW_DB' });

// Source
export const editSource = (source) => ({ type: 'SOURCE_EDIT', payload: source });

export const cancelSource = () => ({ type: 'SOURCE_CANCEL' });

export const deleteSource = (id) => {
	let form = new FormData();
	form.append('id', id);
	return post('SOURCE_DELETE', `/admin/source/delete`, form);
};

export const saveSource = ({ id, fullName }) => {
	let form = new FormData();
	form.append('id', id);
	form.append('fullName', fullName);

	return post('SOURCE_SAVE', `/admin/source/update`, form);
};

export const showNewSourceDialog = () => ({ type: 'CONFIG_NEW_SOURCE' });

// SBL
export const editSblGroup = (sblGroup) => ({ type: 'SBL_GROUP_EDIT', payload: sblGroup });

export const cancelSblGroup = () => ({ type: 'SBL_GROUP_CANCEL' });

export const deleteSblGroup = (id) => {
	let form = new FormData();
	form.append('id', id);
	return post('SBL_GROUP_DELETE', `/admin/sblgroup/delete`, form);
};

export const saveSblgroup = ({ id, name, database }) => {
	let form = new FormData();
	form.append('id', id);
	form.append('name', name);
	form.append('database', database);

	return post('SBL_GROUP_SAVE', `/admin/sblgroup/update`, form);
};

export const showNewSblGroupDialog = () => ({ type: 'CONFIG_NEW_SBL_GROUP' });

// all tabs

export const onChangeTab = (activeKey) => ({ type: 'CONFIG_CHANGE_TAB', payload: activeKey });

export const editInput = (payload) => ({ type: 'CONFIG_EDIT_INPUT', payload });

export const showCreateNew = (value) => ({ type: 'CONFIG_SHOW_CREATE_NEW', payload: value });



// WEBPACK FOOTER //
// ./src/config/configActions.js